var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmssubsendsms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9317_12159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2346 5.68609C20.6666 4.49109 19.5086 3.33309 18.3136 3.76609L3.70855 9.04809C2.50955 9.48209 2.36455 11.1181 3.46755 11.7571L8.12955 14.4561L12.2926 10.2931C12.4812 10.1109 12.7338 10.0101 12.996 10.0124C13.2582 10.0147 13.509 10.1199 13.6944 10.3053C13.8798 10.4907 13.9849 10.7415 13.9872 11.0037C13.9895 11.2659 13.8887 11.5185 13.7066 11.7071L9.54355 15.8701L12.2436 20.5321C12.8816 21.6351 14.5176 21.4891 14.9516 20.2911L20.2346 5.68609Z",
    fill: "#F05865"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9317_12159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmssubsendsms);
export default __webpack_public_path__ + "static/media/smssubsendsms.2aae79f646c31c9328c61b9fd30ae8e3.svg";
export { ForwardRef as ReactComponent };